"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Container {
    constructor(state) {
        this.state = state;
        this.subscribers = new Set();
        this.initialized = false;
    }
    notify() {
        for (const subscriber of this.subscribers) {
            subscriber();
        }
    }
}
exports.Container = Container;
